import { render, staticRenderFns } from "./user-manual.vue?vue&type=template&id=1ccc6be1&scoped=true"
import script from "./user-manual.vue?vue&type=script&lang=js"
export * from "./user-manual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccc6be1",
  null
  
)

export default component.exports